import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import { Row, Col, Spinner, Label, Form, CardTitle } from "reactstrap"
import { withRouter } from "react-router"
import Select from "react-select"
import { Slide, toast, ToastContainer } from "react-toastify"
import FileDownload from "js-file-download"

const DataTablePlanEtude = props => {
  const [loading, setLoading] = useState(false)
  const [cycle, setCycle] = useState([])
  const [selectCycle, setSelectCycle] = useState("")
  const [selectNiveau, setSelectNiveau] = useState("")
  const [niveau, setNiveau] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [annee, setAnnee] = useState("")
  const [imp, setImp] = useState(0)
  const [excel, setExcel] = useState(0)
  useEffect(async () => {
    const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "PDF / EXCEL")
    )
    setImp(typeArticleSubMenu.sous_menu[0].imp)
    setExcel(typeArticleSubMenu.sous_menu[0].exel)
    var userAuthScolarite = JSON.parse(
      localStorage.getItem("userAuthScolarite")
    )
    var annee_id = userAuthScolarite.user.annee_id
    setAnnee(annee_id)
    // cycle
    const res = await API.get("cycle/select").then(res => {
      setCycle(res.data.Cycle)
    })
    //niveau
    const resNiveau = await API.get("niveau/select").then(resNiveau => {
      setNiveau(resNiveau.data.Niveau)
    })
    setLoading(true)
  }, [])
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  const getSpecialite = async event => {
    setSelectNiveau(event)
    setSelectSpecialite("")
    const res = await API.post("specialite/get_by_niveaux_cycle", {
      niveau_id: event.value,
      cycle_id: selectCycle.value,annee_id
    }).then(res => {
      setSpecialite(res.data.Specialites)
    })
  }
  const cycles = async event => {
    setSelectCycle(event)
    if (event.value == 2 || event.value == 3) {
      setNiveau([
        { value: 1, label: "1 ère Année" },
        { value: 2, label: "2 ème Année " },
      ])
    } else {
      API.get("niveau/select").then(resNiveau => {
        setNiveau(resNiveau.data.Niveau)
      })
    }
    setSelectNiveau("")
    setSelectSpecialite("")
  }

  const uploadPDF = async () => {
      window.open("https://flshs.scolarite.backcresus-institut.ovh/api/pdf/etudiants_par_diplome/" +annee,"_blank")
  }
  const uploadPDFTab1 = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/pdf_tableau1/" +
        annee,
      "_blank"
    )
  }
  const uploadPDFTab2 = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/pdf_tableau2/" +
        annee,
      "_blank"
    )
  }
  const uploadPDFTab3 = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/pdf_tableau3/" +
        annee,
      "_blank"
    )
  }
  const uploadExcel = async () => {
    const res = await API.get(`excel/etudiants_par_diplome/${annee}`, {
      responseType: "blob",
    }).then(res => {
      FileDownload(res.data, "ملحق عدد 1.xlsx")
    })
  }
  const uploadExcelTab1 = async () => {
    const res = await API.get(`excel/export_tableau1/${annee}`, {
      responseType: "blob",
    }).then(res => {
      FileDownload(res.data, "جدول عدد 1.xlsx")
    })
  }
  const uploadExcelTab2 = async () => {
    const res = await API.get(`excel/export_tableau2/${annee}`, {
      responseType: "blob",
    }).then(res => {
      FileDownload(res.data, "جدول عدد 1.xlsx")
    })
  }
  const uploadExcelTab3 = async () => {
    const res = await API.get(`excel/export_tableau3/${annee}`, {
      responseType: "blob",
    }).then(res => {
      FileDownload(res.data, "جدول عدد 3.xlsx")
    })
  }
  const uploadExcelRepartition = async () => {
      const res = await API.get(`excel/heures_par_enseignant/${annee}`, {
        responseType: "blob",
      }).then(res => {
        FileDownload(res.data, "ﻣﻠﺤﻖ عدد 03.xlsx")
      })

  }
  const uploadPDFRepartition = async () => {
      window.open(
        "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/heures_par_enseignant/" +
          annee,
        "_blank"
      )
  }
  const uploadPDFRepartitionNombre = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/heures_par_matiere/" +
        annee,
      "_blank"
    )
  }
  const uploadExcelRepartitionNombre = async () => {
    const res = await API.get(`excel/heures_par_matiere/${annee}`, {
      responseType: "blob",
    }).then(res => {
      FileDownload(res.data, "ملحق عدد 02.xlsx")
    })
  }
  const uploadPDFHeureSupp = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/charge_horaire_supp/" +
        annee,
      "_blank"
    )
  }
  const uploadExcelHeureSupp = async () => {
    const res = await API.get(`excel/charge_horaire_supp/${annee}`, {
      responseType: "blob",
    }).then(res => {
      FileDownload(res.data, "بيانات ساعات التدريس التكميلية.xlsx")
    })
  }
  const uploadPDFEnseignantPer = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/list_enseignant_permanant_charge_horaires_supp/" +
        annee,
      "_blank"
    )
  }
  const uploadExcelEnseignantPer = async () => {
    const res = await API.get(
      `excel/list_enseignant_permanant_charge_horaires_supp/${annee}`,
      { responseType: "blob" }
    ).then(res => {
      FileDownload(
        res.data,
        "قائمة في المدرسين القارين والمتعاقدين الذين انجزوا ساعات تكميلية.xlsx"
      )
    })
  }
  const uploadPDFEnseignantVac = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/calcul_charge_horaires_vacataire/" +
        annee,
      "_blank"
    )
  }
  const uploadExcelEnseignantVac = async () => {
    const res = await API.get(
      `excel/calcul_charge_horaires_vacataire/${annee}`,
      { responseType: "blob" }
    ).then(res => {
      FileDownload(res.data, "قائمة في المدرسين العرضيين.xlsx")
    })
  }
  const uploadPDFEnseignantPerCont = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/enseignant_permanant/" +
        annee,
      "_blank"
    )
  }
  const uploadExcelEnseignantPerCont = async () => {
    const res = await API.get(`excel/enseignant_permanant/${annee}`, {
      responseType: "blob",
    }).then(res => {
      FileDownload(res.data, "قائمة في المدرسين القارين و المتعاقدين.xlsx")
    })
  }
  const uploadPDFEnseignantCont = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/calcul_charge_horaires_permanant/" +
        annee,
      "_blank"
    )
  }
  const uploadPDFTous = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/pdf_tous/" +
        annee,
      "_blank"
    )
  }
  const uploadPDFMoyen = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/pdf_permanents_moyen/" +
        annee,
      "_blank"
    )
  }
  const uploadPDFPeu = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/pdf_permanents_peu/" +
        annee,
      "_blank"
    )
  }
  const uploadPDFBoucoup = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/pdf_permanents_beaucoup/" +
        annee,
      "_blank"
    )
  }
  const uploadPDFCont = async () => {
    window.open(
      "https://flshs.scolarite.backcresus-institut.ovh/api/pdf/pdf_contractuels/" +
        annee,
      "_blank"
    )
  }
  const uploadExcelEnseignantCont = async () => {
    const res = await API.get(
      `excel/calcul_charge_horaires_permanant/${annee}`,
      { responseType: "blob" }
    ).then(res => {
      FileDownload(
        res.data,
        "جدول بياني في ساعات التدريس للمدرسين القارين و المتعاقدين المؤمنة للسنة الجامعية.xlsx"
      )
    })
  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row>
            <Form>
              <Row>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDF}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p> {"ملحق عدد 01 "}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcel}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p> {"ملحق عدد 01 "}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFRepartitionNombre}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p> {"ﻣﻠﺤﻖ ﻋﺪد 02"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcelRepartitionNombre}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p> {"ﻣﻠﺤﻖ ﻋﺪد 02"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
              </Row>

              <Row>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFRepartition}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p> {"ﻣﻠﺤﻖ ﻋﺪد 03"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcelRepartition}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p> {"ﻣﻠﺤﻖ ﻋﺪد 03"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFEnseignantVac}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p> {"ﺟﺪول ﻋﺪد 02"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcelEnseignantVac}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p> {"ﺟﺪول ﻋﺪد 02"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFEnseignantPerCont}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p> {"ﺟﺪول ﻋﺪد 04"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcelEnseignantPerCont}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p> {"ﺟﺪول ﻋﺪد 04"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFEnseignantPer}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p>
                          {
                            "ﻗﺎﺋﻤﺔ ﻓﻲ اﻟﻤﺪرﺳﻴﻦ اﻟﻘﺎرﻳﻦ واﻟﻤﺘﻌﺎﻗﺪﻳﻦ اﻟﺬﻳﻦ اﻧﺠﺰوا ﺳﺎﻋﺎت ﺗﻜﻤﻴﻠﻴﺔ "
                          }
                        </p>
                        <p>{"( ﻣﻠﺤﻖ ﻋﺪد 04 )"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcelEnseignantPer}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p>
                          {
                            "ﻗﺎﺋﻤﺔ ﻓﻲ اﻟﻤﺪرﺳﻴﻦ اﻟﻘﺎرﻳﻦ واﻟﻤﺘﻌﺎﻗﺪﻳﻦ اﻟﺬﻳﻦ اﻧﺠﺰوا ﺳﺎﻋﺎت ﺗﻜﻤﻴﻠﻴﺔ"
                          }
                        </p>
                        <p>{"( ﻣﻠﺤﻖ ﻋﺪد 04 )"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFTous}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p>
                          {
                            "ﺟﺪول ﺑﻴﺎﻧﻲ ﻓﻲ ﺳﺎﻋﺎت اﻟﺘﺪرﻳﺲ ﻟﻠﻤﺪرﺳﻴﻦ اﻟﻘﺎرﻳﻦ و اﻟﻤﺘﻌﺎﻗﺪﻳﻦ اﻟﻤﺆﻣﻨﺔ"
                          }
                        </p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFPeu}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p>
                          {
                            "ﺟﺪول ﺑﻴﺎﻧﻲ ﻓﻲ ﺳﺎﻋﺎت اﻟﺘﺪرﻳﺲ ﻟﻠﻤﺪرﺳﻴﻦ اﻟﻘﺎرﻳﻦ و اﻟﻤﺘﻌﺎﻗﺪﻳﻦ اﻟﻤﺆﻣﻨﺔ"
                          }
                        </p>
                        <p>{" القارين - ساعات إضافية ≤ 2"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFMoyen}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p>
                          {
                            "ﺟﺪول ﺑﻴﺎﻧﻲ ﻓﻲ ﺳﺎﻋﺎت اﻟﺘﺪرﻳﺲ ﻟﻠﻤﺪرﺳﻴﻦ اﻟﻘﺎرﻳﻦ و اﻟﻤﺘﻌﺎﻗﺪﻳﻦ اﻟﻤﺆﻣﻨﺔ"
                          }
                        </p>
                        <p>{" القارين - ساعات إضافية بين 2 و 4"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFBoucoup}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p>
                          {
                            "ﺟﺪول ﺑﻴﺎﻧﻲ ﻓﻲ ﺳﺎﻋﺎت اﻟﺘﺪرﻳﺲ ﻟﻠﻤﺪرﺳﻴﻦ اﻟﻘﺎرﻳﻦ و اﻟﻤﺘﻌﺎﻗﺪﻳﻦ اﻟﻤﺆﻣﻨﺔ"
                          }
                        </p>
                        <p>{" القارين - ساعات إضافية > 4"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFCont}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p>
                          {
                            "ﺟﺪول ﺑﻴﺎﻧﻲ ﻓﻲ ﺳﺎﻋﺎت اﻟﺘﺪرﻳﺲ ﻟﻠﻤﺪرﺳﻴﻦ اﻟﻘﺎرﻳﻦ و اﻟﻤﺘﻌﺎﻗﺪﻳﻦ اﻟﻤﺆﻣﻨﺔ"
                          }
                        </p>
                        <p>{" المتعاقدين"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcelEnseignantCont}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p> {"ﺟﺪول ﺑﻴﺎﻧﻲ ﻓﻲ ﺳﺎﻋﺎت اﻟﺘﺪرﻳﺲ"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
              </Row>

              <Row>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFTab1}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p> {"جدول عدد 01  ( Nouveau  )"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcelTab1}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p> {"جدول عدد 01 ( Nouveau  )"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFTab2}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p> {"جدول ﻋﺪد 02 ( Nouveau  )"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcelTab2}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p> {"جدول ﻋﺪد 02 ( Nouveau  )"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {imp === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn  mb-2 me-2"
                        onClick={uploadPDFTab3}
                        style={{
                          height: "80px",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "#761C19",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-pdf"
                        ></i>
                        <p> {"جدول عدد 03  ( Nouveau  )"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
                <Col lg="3" style={{ textAlign: "center" }}>
                  {excel === 1 ? (
                    <div className="text-center mt-4">
                      <a
                        className="btn mb-2 me-2"
                        onClick={uploadExcelTab3}
                        style={{
                          height: "80px",
                          backgroundColor: "none",
                          borderColor: "#7d7b7b",
                          width: "100%",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "30px",
                            margin: "0px 6px 0px 0px",
                          }}
                          className="fas fa-file-excel"
                        ></i>
                        <p> {"جدول عدد 03 ( Nouveau  )"}</p>
                      </a>
                    </div>
                  ) : null}
                </Col>
              </Row>
            </Form>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              En cours ...{" "}
            </h4>
          </div>
        )}
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}
export default withRouter(DataTablePlanEtude)
DataTablePlanEtude.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
}
